import _ from 'underscore';
import React from 'react';

import BroadcastCard from 'components/cards/BroadcastCard';
import Container from 'components/Container';
import MultirowSlideSection from 'components/MultirowSlideSection';
import Section from 'components/Section';
import SimpleGrid from 'components/SimpleGrid';
import SizeDependedBlock from 'components/SizeDependedBlock';

import EntitiesPropTypes from 'utils/propTypes/entities';

const Catalog = ({ actualMovies, archiveMovies }) => {
	const isArchive = _.isEmpty(actualMovies);
	const sectionTitle = isArchive ? 'Архив' : 'Ближайшие трансляции';
	const movies = isArchive ? archiveMovies : actualMovies;
	const moreControls = [
		{
			title: 'Расписание',
			url: '/national-streaming/schedule'
		},
		{
			title: 'Архив',
			url: '/national-streaming/archive'
		}
	];

	const moreControl =
		isArchive || actualMovies.length <= 4 ? moreControls[1] : moreControls[0];

	return (
		<SizeDependedBlock>
			<MultirowSlideSection
				title={sectionTitle}
				items={movies}
				moreControl={moreControl}
				CardComponent={BroadcastCard}
				gridSize={2}
				direction="columns"
			/>
			<Section title={sectionTitle} moreControl={moreControl}>
				<Container>
					<SimpleGrid>
						{_(movies).map((block) => (
							<BroadcastCard key={block._id} data={block} />
						))}
					</SimpleGrid>
				</Container>
			</Section>
		</SizeDependedBlock>
	);
};

Catalog.propTypes = {
	actualMovies: EntitiesPropTypes.broadcast.isRequired,
	archiveMovies: EntitiesPropTypes.broadcast.isRequired
};

export default Catalog;
